import React from 'react';
import { motion } from 'framer-motion';
import { navyGrid } from '../theme';

/**
 * Navy header band that opens every inner page — the website counterpart of the
 * design system's "CV — Navy Header" layout. Type-first: small uppercase
 * eyebrow, Lora title, optional lead paragraph.
 */
const PageHeader = ({ eyebrow, title, lead, children }) => (
  <header className="relative overflow-hidden bg-navy-900 text-[color:var(--on-navy)]">
    <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={navyGrid} />
    <div className="relative mx-auto max-w-5xl px-6 py-16 md:px-10 md:py-20">
      {eyebrow && (
        <motion.p
          className="mb-4 text-xs font-semibold uppercase tracking-label text-[#A6C0DB]"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {eyebrow}
        </motion.p>
      )}
      <motion.h1
        className="font-display text-4xl font-semibold leading-[1.06] tracking-tight text-[color:var(--on-navy)] md:text-5xl"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        {title}
      </motion.h1>
      {lead && (
        <motion.p
          className="mt-5 max-w-2xl text-base leading-relaxed text-[#C6D6E6] md:text-lg"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.16 }}
        >
          {lead}
        </motion.p>
      )}
      {children && <div className="mt-8">{children}</div>}
    </div>
  </header>
);

export default PageHeader;
